import { Injectable } from '@angular/core';
import { TaskRepository } from 'src/app/domain/service/task/task-repository';
import { Task } from 'src/app/domain/model/task/task.model';

@Injectable({ providedIn: 'root' })
export class InMemoryTaskRepository implements TaskRepository {
  private tasks: Task[] = [
    { id: '1', title: 'Aprender Angular', completed: false },
    { id: '2', title: 'Implementar Use Case', completed: false },
    { id: '3', title: 'Aplicar Inyección de Dependencias', completed: true }
  ];

  getTasks(): Promise<Task[]> {
    return Promise.resolve([...this.tasks]);
  }

  addTask(title: string): Promise<Task> {
    const newTask: Task = {
      id: (Math.random() * 100000).toFixed(0),
      title,
      completed: false
    };
    this.tasks.push(newTask);
    return Promise.resolve(newTask);
  }

  removeTask(id: string): Promise<void> {
    this.tasks = this.tasks.filter((t) => t.id !== id);
    return Promise.resolve();
  }

  toggleTask(id: string): Promise<Task> {
    const task = this.tasks.find((t) => t.id === id);
    if (task) {
      task.completed = !task.completed;
      return Promise.resolve(task);
    }
    return Promise.reject('Task not found');
  }
}
